import { ReactNode } from 'react';
import { CopyButton } from './CopyButton';
import styles from './HoverableCopyBlock.module.css';

export function HoverableCopyBlock({ text, children }: { text: string; children: ReactNode }) {
  return (
    <div className={styles.wrapper}>
      {children}
      <div className={styles.copyBtn}>
        <CopyButton text={text} />
      </div>
    </div>
  );
}
